@use '@/styles/tokens' as *;

// The two DateRangePickers are not <FormField>s, so they carry their own label + error chrome.
// Values map to Figma 350:290001 / 350:290004 (label = Text/Secondary, gap = spacing/1).
.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0 0 var(--space-4);
  padding: 0;
  border: 0;
}

.legend {
  padding: 0 var(--space-2);
  font-size: $font-size-md;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

// 11px / 300 are below the token scale's floor ($font-size-xs is 12px, $font-weight-regular
// is 400) — the shared form-field error styling this mirrors uses the same raw values.
.error {
  margin: 0;
  padding-inline: var(--space-2);
  font-size: 11px;
  font-weight: 300;
  color: $color-error-900;
}
